var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('div', {
    staticClass: "float-right pr-4"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.show = !_vm.show;
      }
    }
  }, [_vm.show ? _c('v-icon', [_vm._v("mdi-chevron-up")]) : _c('v-icon', [_vm._v("mdi-chevron-down")])], 1)], 1), _c('p', {
    staticClass: "title px-4 primary--text",
    on: {
      "click": function click($event) {
        _vm.show = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Illust')))]), _c('v-expand-transition', [_c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "px-2 mt-n2 mb-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_vm.character.m_Rare == 2 ? [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.characard.format(_vm.evolutionID(0)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 3 / 4,
      "src": _vm.$asset.characard.format(_vm.evolutionID(0)) + '.jpg'
    }
  })], 1)]), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.charaillustchara.format(_vm.evolutionID(0)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 3 / 4,
      "src": _vm.$asset.charaillustchara.format(_vm.evolutionID(0)) + '.jpg'
    }
  })], 1)]), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3",
      "sm": "4"
    }
  }), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3",
      "sm": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.mergedcharaicon.format(_vm.evolutionID(0)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 1,
      "src": _vm.$asset.mergedcharaicon.format(_vm.evolutionID(0)) + '.png'
    }
  })], 1)]), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3",
      "sm": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.charaicon.format(_vm.evolutionID(0)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 1,
      "src": _vm.$asset.charaicon.format(_vm.evolutionID(0)) + '.png'
    }
  })], 1)]), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3",
      "sm": "4"
    }
  })] : _vm.character.m_Rare == 3 ? [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.characard.format(_vm.evolutionID(0)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 3 / 4,
      "src": _vm.$asset.characard.format(_vm.evolutionID(0)) + '.jpg'
    }
  })], 1)]), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.characard.format(_vm.evolutionID(1)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 3 / 4,
      "src": _vm.$asset.characard.format(_vm.evolutionID(1)) + '.jpg'
    }
  })], 1)]), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.charaillustchara.format(_vm.evolutionID(0)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 3 / 4,
      "src": _vm.$asset.charaillustchara.format(_vm.evolutionID(0)) + '.jpg'
    }
  })], 1)]), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.charaillustchara.format(_vm.evolutionID(1)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 3 / 4,
      "src": _vm.$asset.charaillustchara.format(_vm.evolutionID(1)) + '.jpg'
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "0",
      "sm": "2"
    }
  }), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3",
      "sm": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.mergedcharaicon.format(_vm.evolutionID(0)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 1,
      "src": _vm.$asset.mergedcharaicon.format(_vm.evolutionID(0)) + '.png'
    }
  })], 1)]), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3",
      "sm": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.charaicon.format(_vm.evolutionID(0)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 1,
      "src": _vm.$asset.charaicon.format(_vm.evolutionID(0)) + '.png'
    }
  })], 1)]), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3",
      "sm": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.mergedcharaicon.format(_vm.evolutionID(1)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 1,
      "src": _vm.$asset.mergedcharaicon.format(_vm.evolutionID(1)) + '.png'
    }
  })], 1)]), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3",
      "sm": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.charaicon.format(_vm.evolutionID(1)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 1,
      "src": _vm.$asset.charaicon.format(_vm.evolutionID(1)) + '.png'
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "0",
      "sm": "2"
    }
  })] : _vm.character.m_Rare == 4 ? [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.characard.format(_vm.evolutionID(0)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 3 / 4,
      "src": _vm.$asset.characard.format(_vm.evolutionID(0)) + '.jpg'
    }
  })], 1)]), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.characard.format(_vm.evolutionID(1)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 3 / 4,
      "src": _vm.$asset.characard.format(_vm.evolutionID(1)) + '.jpg'
    }
  })], 1)]), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.charaillustfull.format(_vm.evolutionID(0)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 3 / 4,
      "src": _vm.$asset.charaillustfull.format(_vm.evolutionID(0)) + '.jpg'
    }
  })], 1)]), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.charaillustfull.format(_vm.evolutionID(1)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 3 / 4,
      "src": _vm.$asset.charaillustfull.format(_vm.evolutionID(1)) + '.jpg'
    }
  })], 1)]), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.charaillustchara.format(_vm.evolutionID(0)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 3 / 4,
      "src": _vm.$asset.charaillustchara.format(_vm.evolutionID(0)) + '.jpg'
    }
  })], 1)]), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.charaillustchara.format(_vm.evolutionID(1)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 3 / 4,
      "src": _vm.$asset.charaillustchara.format(_vm.evolutionID(1)) + '.jpg'
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "0",
      "sm": "2"
    }
  }), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3",
      "sm": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.mergedcharaicon.format(_vm.evolutionID(0)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 1,
      "src": _vm.$asset.mergedcharaicon.format(_vm.evolutionID(0)) + '.png'
    }
  })], 1)]), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3",
      "sm": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.charaicon.format(_vm.evolutionID(0)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 1,
      "src": _vm.$asset.charaicon.format(_vm.evolutionID(0)) + '.png'
    }
  })], 1)]), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3",
      "sm": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.mergedcharaicon.format(_vm.evolutionID(1)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 1,
      "src": _vm.$asset.mergedcharaicon.format(_vm.evolutionID(1)) + '.png'
    }
  })], 1)]), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3",
      "sm": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.charaicon.format(_vm.evolutionID(1)) + '.png',
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 1,
      "src": _vm.$asset.charaicon.format(_vm.evolutionID(1)) + '.png'
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "0",
      "sm": "2"
    }
  })] : _vm._e()], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }